import { render } from "./errorPage4.vue?vue&type=template&id=746f9bb0"
import script from "./errorPage4.vue?vue&type=script&lang=js"
export * from "./errorPage4.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__